import React, { Component } from 'react';
import { Link } from 'react-router';

import routeConfig from '../../config/route.json';

import '../../css/mobile-menu.css';

import $ from 'jquery';

class Menu extends Component {

  constructor(props) {
    super(props);
    this.state = this.props;

    this.toggleMenuPanel = this.toggleMenuPanel.bind(this);
    this.initMenuPanel = this.initMenuPanel.bind(this);
    this.changePositioning = this.changePositioning.bind(this);
  }

  componentWillMount() {
    
  }

  componentDidMount() {
    let t = this;

    this.changePositioning();
    window.addEventListener('resize', this.changePositioning);
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.changePositioning);
  }

  changePositioning() {
    let t = this;
    this.initMenuPanel();

    setTimeout(function(){
      t.initMenuPanel();
    }, 500)

    setTimeout(function(){
      t.initMenuPanel();
    }, 1000)

    setTimeout(function(){
      t.initMenuPanel();
    }, 1500)
    
    let triggerRight = $('#mobile-menu-trigger-button').css('right')
    triggerRight = parseFloat(triggerRight.slice(0, triggerRight.length - 2)) * 0.7 + 'px'
    $('#mobile-menu-trigger-button').css({
      'top': triggerRight,
      'height': $('#mobile-menu-trigger-button').css('width')
    });
  }

  initMenuPanel() {
    let windowHeight = $(window).height();

    let mobileMenuPanelContainer = $('#mobile-menu-panel-container').css('left')

    $('#mobile-menu-close-button').css({
      // 'top': $('#mobile-menu-close-button').css('right'),
      top: 0,
      height: $('#mobile-menu-close-button').css('width')
    });

    $('.mobile-menu-navigation-button').css({
      height: $('#mobile-menu-close-button').css('width')
    });
  }

  toggleMenuPanel() {
    console.log(this.state.panelIsOpen)

    if (this.state.panelIsOpen) {
      $('#mobile-menu-panel-container').fadeOut();
    } else {
      $('#mobile-menu-panel-container').fadeIn();
      this.initMenuPanel();
    }
    
    this.setState({
      panelIsOpen: !this.state.panelIsOpen
    });
  }

  render() {
    return <div id='mobile-menu-container' className=''>
        <div className='' id='mobile-menu-trigger-button' style={{}} onClick={this.toggleMenuPanel}></div>

        <div className='' id='mobile-menu-panel-container' style={{
          'display': 'none'
        }}>
          <img className='' id='mobile-menu-panel' src={'/p2/mobile/menu/' + this.props.lang + '/panel.png'} style={{}}/>

          <div className='mobile-menu-button' id='mobile-menu-close-button' style={{
            
          }} onClick={this.toggleMenuPanel}>
          </div>

          <Link to={() => {
            let lang = this.props.lang == 'en' ? 'tc' : 'en';
            let pathArr = window.location.pathname.split('/');
            let pageName = pathArr[pathArr.length-1];
  
            return '/p2/m/' + lang + '/' + pageName;

            // let subRoute = window.location.hash.split('/')[3] ? '/' + window.location.hash.split('/')[3] : ''
            
            // console.log('/m/' + lang + subRoute)
            // return '/m/' + lang + subRoute
          }} onClick={this.toggleMenuPanel}>
            <div className='mobile-menu-button mobile-menu-navigation-button' id='' style={{
              'top': '1%',
              'width': '10%',
              'left': '2%'
            }}>
            </div>
          </Link>

          <Link to={() => {
            let lang = this.props.lang == 'sc' ? 'tc' : 'sc';
            let pathArr = window.location.pathname.split('/');
            let pageName = pathArr[pathArr.length-1];
  
            return '/p2/m/' + lang + '/' + pageName;

            // let subRoute = window.location.hash.split('/')[3] ? '/' + window.location.hash.split('/')[3] : ''
            
            // console.log('/m/' + lang + subRoute)
            // return '/m/' + lang + subRoute
          }} onClick={this.toggleMenuPanel}>
            <div className='mobile-menu-button mobile-menu-navigation-button' id='' style={{
              'top': '1%',
              'width': '8%',
              'left': '13%'
            }}>
            </div>
          </Link>

          <Link to={routeConfig.salesBrochure[this.props.lang].mobileUrl} onClick={this.toggleMenuPanel}>
            <div className='mobile-menu-button mobile-menu-navigation-button' id='mobile-menu-navigation-salesBrochure' style={{
              'top': '6.5%'
            }}>
            </div>
          </Link>

          <Link to={routeConfig.priceList[this.props.lang].mobileUrl} onClick={this.toggleMenuPanel}>
            <div className='mobile-menu-button mobile-menu-navigation-button' id='mobile-menu-navigation-priceList' style={{
              'top': '12.2%'
            }}>
            </div>
          </Link>

          <Link to={routeConfig.salesArrangements[this.props.lang].mobileUrl} onClick={this.toggleMenuPanel}>
            <div className='mobile-menu-button mobile-menu-navigation-button' id='mobile-menu-navigation-salesArrangements' style={{
              'top': '17.9%'
            }}>
            </div>
          </Link>

          <Link to={routeConfig.registerOfTransactions[this.props.lang].mobileUrl} onClick={this.toggleMenuPanel}>
            <div className='mobile-menu-button mobile-menu-navigation-button' id='mobile-menu-navigation-registerOfTransactions' style={{
              'top': '23.7%'
            }}>
            </div>
          </Link>

          <Link to={routeConfig.deedOfMutualCovenant[this.props.lang].mobileUrl} onClick={this.toggleMenuPanel}>
            <div className='mobile-menu-button mobile-menu-navigation-button' id='mobile-menu-navigation-deedOfMutualCovenant' style={{
              'top': '29.5%'
            }}>
            </div>
          </Link>

          <Link to={routeConfig.aerialPhotograph[this.props.lang].mobileUrl} onClick={this.toggleMenuPanel}>
            <div className='mobile-menu-button mobile-menu-navigation-button' id='mobile-menu-navigation-aerialPhotograph' style={{
              'top': '35.3%'
            }}>
            </div>
          </Link>

          <Link to={routeConfig.announcement[this.props.lang].mobileUrl} onClick={this.toggleMenuPanel}>
            <div className='mobile-menu-button mobile-menu-navigation-button' id='mobile-menu-navigation-announcement' style={{
              'top': '40.6%'
            }}>
            </div>
          </Link>

          <Link to={routeConfig.gallery[this.props.lang].mobileUrl} onClick={this.toggleMenuPanel}>
            <div className='mobile-menu-button mobile-menu-navigation-button' id='mobile-menu-navigation-gallery' style={{
              'top': '47%'
            }}>
            </div>
          </Link>

          <Link to={routeConfig.tenderDocuments[this.props.lang].mobileUrl} onClick={this.toggleMenuPanel}>
            <div className='mobile-menu-button mobile-menu-navigation-button' id='mobile-menu-navigation-tenderDocuments' style={{
              'top': '53%'
            }}>
            </div>
          </Link>

          {/* <Link to={routeConfig.application[this.props.lang].mobileUrl} onClick={this.toggleMenuPanel}>
            <div className='mobile-menu-button mobile-menu-navigation-button' id='mobile-menu-navigation-gallery' style={{
              'top': '49.5%'
            }}>
            </div>
          </Link> */}
        </div>
    </div>
  }
}


export default Menu;




// WEBPACK FOOTER //
// ./src/mobile/layout/Menu.js